var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('nav-bar-comp'),_c('router-view',{staticClass:"router"}),_c('footer-comp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }